import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/stockConfigure';
import { get, post, del } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getStocks({ payload }) {
  try {
    const response = yield call(get, `/stock?activeOnly=${payload.activeOnly}&plantId=${payload.plantId}`);
    yield put(actions.getStockConfigureListSuccess(response));
  } catch (e) {
    yield put(actions.getStockConfigureListFail(e.response.data));
  }
}

export function* addNewStockLevel({ payload }) {
  try {
    yield call(post, '/stock', payload);
    yield put(actions.addNewStockLevelSuccess());
  } catch (e) {
    modalErrorOpen({
      message: e.response.data.message,
      techInfo: e.response.data.techInfo,
      types: 'error',
      title: formatMessage('textError').warning
    });
    yield put(actions.addNewStockLevelFail(e.response.data));
  }
}

export function* deleteStockLevel({ payload }) {
  try {
    yield call(del, `/stock?stockId=${payload.stockId}`);
    yield put(actions.deleteStockLevelSuccess());
  } catch (e) {
    modalErrorOpen({
      message: e.response.data.message,
      techInfo: e.response.data.techInfo,
      types: 'error',
      title: formatMessage('textError').warning
    });
    yield put(actions.deleteStockLevelFail(e.response.data));
  }
}
